import React, { useEffect, useState, useCallback } from 'react';

const CompareUrls = ({ urls, onGenerateRegex = () => {}, matchingRule }) => {
  const [regexPattern, setRegexPattern] = useState('');

  // Helper to escape special regex characters
  const escapeRegex = useCallback((text) => {
    // eslint-disable-next-line no-useless-escape
    return text.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }, []);

  // ✅ Memoized generateRegexPattern function
  const generateRegexPattern = useCallback((urls) => {
    const splitUrls = urls.map(url => url.split(/([A-Za-z0-9_-]+)/));
    let regexPattern = '';

    for (let i = 0; i < splitUrls[0].length; i++) {
      const partSet = new Set(splitUrls.map(parts => parts[i]));
      if (partSet.size === 1 && partSet.has(splitUrls[0][i])) {
        regexPattern += escapeRegex(splitUrls[0][i]);
      } else {
        regexPattern += '([A-Za-z0-9_-]+)';
      }
    }

    return regexPattern;
  }, [escapeRegex]);

  // ✅ Memoized applyMatchingRule function
  const applyMatchingRule = useCallback((regexPattern) => {
    switch (matchingRule) {
      case 'whole': return `^${regexPattern}$`;
      case 'start': return `^${regexPattern}`;
      case 'end': return `${regexPattern}$`;
      case 'any': return regexPattern;
      default: return regexPattern;
    }
  }, [matchingRule]);

  useEffect(() => {
    if (urls.length < 2) {
      console.log("Please provide at least two URLs to compare.");
      return;
    }

    const pattern = generateRegexPattern(urls);
    const adjustedPattern = applyMatchingRule(pattern);
    setRegexPattern(adjustedPattern);
    onGenerateRegex(adjustedPattern);
  }, [urls, onGenerateRegex, generateRegexPattern, applyMatchingRule]);

  return (
    <div>
      <h3>Generated Regex Pattern:</h3>
      <p>{regexPattern}</p>
    </div>
  );
};

export default CompareUrls;
